/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-03 00:00:00
 *
 *******************************************************/
import React, { Component } from 'react';
import { Modal, Card, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class ChangedTemplateModal extends Component<ComposedProps, State> {
  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  render() {
    const { open, onClose, loading, templateName, i18n } = this.props;

    return (
      <div>
        <Modal
          open={open}
          onClose={onClose}
          title={i18n.translate('AdminHTML.ShopifyIntegration.ChangeTemplateModal.title')}
          primaryAction={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.yes'),
              onAction: () => {
                this.props.onConfirm();
              },
              loading: loading
            }
          ]}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.no'),
              onAction: this.props.onClose
            }
          ]}>
          {/* Content */}
          <div className="change-template-modal">
            <Card>
              <Card.Section>
                <div className="content">
                  {i18n.translate('AdminHTML.ShopifyIntegration.ChangeTemplateModal.content', {
                    t1: <TextStyle variation="strong">{templateName}</TextStyle>
                  })}
                </div>
                <div>
                  {i18n.translate(
                    'AdminHTML.ShopifyIntegration.ChangeTemplateModal.confirmMessage'
                  )}
                </div>
              </Card.Section>
            </Card>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withI18n()(ChangedTemplateModal);
